/**
 * Returns GQL Query for retrieving the event
 *
 * @param eventId Event ID
 */
export function getEvent(eventId: string) {
  return `query {
  event {
    get(eventId: "${eventId}") {
      id
      createdBy
      location
      name
      hostName
      description
      timezoneOffset
      creationTimeZone
      endTime
      isActive
      payoutTime
      onSale
      lastInitialOnly
      currency
      startTime
      ticketCounts{status,count,orders}
      links {
        url
        label
      }
      publicTickets {
        id
        quantity
        bought
        cancelled
        enabled
      }
      ticketBreakBought{price,count}
      ticketBreakCheckedIn{price,count}
      ticketBreakCancelled{price,count}
      ticketBreakActivated{price,count}
      fees {
        absorb
        perTicketFee
        perOrderFee
        perOrderFeeType
        taxPercentage
      }
      configuration {
        whitelist {
          emails
          emailDomains
        }
        maxTicketsPerEmail
        maxTicketsPerOrder
        maxTicketsPerType
        quota
        excludeFree
      }
      styling{
        bgImg
        promoImg
        descripImg
      }
      promoters
      hosts
      checkers
      revenueTotal
      averageDayRevenue
      boughtTotal
      totalPrivate,
      totalPublic,
      ticketsURL,
      stripeFeeTotal,
      platFormFeeTotal
      taxTotal
      capacityRemaining
    }
  }
}
`;
}

export function getEventBreakdownFiltered(
  eventId: string,
  salesChannel?: string,
  promoterId?: string,
) {
  return `query {
  event {
    get(eventId: "${eventId}") {
      id
      ticketBreakBought(salesChannelFilter:"${salesChannel}",promoterId:"${promoterId || ''}"){price,count}
      ticketBreakCheckedIn(salesChannelFilter:"${salesChannel}",promoterId:"${promoterId || ''}"){price,count}
      ticketBreakCancelled(salesChannelFilter:"${salesChannel}",promoterId:"${promoterId || ''}"){price,count}
      ticketBreakActivated(salesChannelFilter:"${salesChannel}",promoterId:"${promoterId || ''}"){price,count}
     
    }
  }
}
`;
}

export function createEvent() {
  return `
  mutation($event:EventNew!){
    event {
      create(
        event: $event
      ) {
        id
      }
    }
  }
`;
}

export function createTime() {
  return `
  mutation($time:TimeInput!){
    time {
      create(
        time: $time
      ) {
        eventId
      }
    }
  }
`;
}

export function updateTime() {
  return `
  mutation($time:TimeInput!){
    time {
      update(
        time: $time
      ) 
    }
  }
`;
}

export function getUsers() {
  return `query($ids:[String!]) {
  user{
    findByIds(ids:$ids) {
    id
    name,
    lastname,
    avatar,
    email,
    createdAt,
    updatedAt
    lastLoginAt
  }
  }
}
`;
}

export function updateEvent() {
  return `mutation($event:EventUpdate!, $eventId:String!) {
  event {
    update( event: $event, eventId: $eventId )
  }
}
`;
}

export function addOrInviteUsers() {
  return `mutation($emails: [String!]!, $eventId: String!, $roleId: String!) {
  event {
    addOrInviteUser(emails: $emails, eventId: $eventId, roleId: $roleId)
  }
}`;
}

export function InviteUsers() {
  return `mutation($emails: [String!]!) {
  event {
    inviteUsers(emails: $emails)
  }
}`;
}

export function changeUserRole() {
  return `mutation($userId: String!, $newRoleId: String!, $eventId: String!) {
  event {
    changeUserRole(userId: $userId, newRoleId: $newRoleId, eventId: $eventId)
  }
}
`;
}

export function updateCurrentUser() {
  return `mutation(
    $email: String!
    $name: String!
    $lastname: String!
    $password: String!
    ) {
    user {
      update(
        user: {
          email: $email
          name: $name
          lastname: $lastname
          password: $password
        }
      )
    }
  }

`;
}



// WEBPACK FOOTER //
// ./src/components/graphql/queries.tsx